import { render, staticRenderFns } from "./TheLogoutConfirm.vue?vue&type=template&id=5a8c0d41"
import script from "./TheLogoutConfirm.vue?vue&type=script&lang=ts"
export * from "./TheLogoutConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports